jQuery(document).ready(function($){
	$('.owl-carousel').owlCarousel({
		animateOut: 'fadeOut',
	    animateIn: 'fadeIn',
	    items: 1,
		loop: true,
		// center: true,
		autoplay: true,
		autoplayTimeout: 3000,
    	autoplayHoverPause: false,
	    // margin:30,
	    // stagePadding:30,
	    // smartSpeed:450,
		mouseDrag: true,
		touchDrag: true,
		nav: false,
		dots: true,
	});


	$(window).paroller();


	$('form').each(function() {
		$(this).validate({
			rules: {
				name: 'required',
				email: {
					required: true,
					email: true
				},
			},
			debug: true,
			submitHandler: function(form) {
				var form_data = $(form).serialize();
				$.ajax({
		            type: 'POST',
		            url:  'sendmail.php',
		            data: form_data,
		            success: function() {
						alert('Ваше сообщение успешно отпрвлено!');
						$(form).find('input').val('');
						$(form).find('textarea').val('');
						$('[data-lity-close]', window.parent.document).trigger('click');
						yaCounter45651453.reachGoal('SENDFORM');
					},
					error: function(){
						alert('Что-то пошло не так. Проверьте введенные данные или попробуйте отправить позже.');
					}
	            });
			}
		});
	});


	var wow = new WOW({
	    boxClass:     'wow',
	    animateClass: 'animated',
	    offset:       0,
	    mobile:       false,
	    live:         true,
	    scrollContainer: null
	});
	wow.init();


	$('.cloud .tag span').each(function() {
		$(this).css('animation-duration', Math.random() * 3 + 3 + 's' );
		$(this).css('animation-delay', Math.random() * 2 + 1 + 's' );
		$(this).css('padding-left', Math.floor(Math.random() * 65 + 102) + '%' );
	});


	$(window).scroll(function(){
		if (window.innerWidth > 991) {
			if ($(this).scrollTop() > 215) {
				$('nav.float-menu').fadeIn(300);
			} else {
				$('nav.float-menu').fadeOut(300);
			}
		} else {
			$('nav.float-menu').fadeOut(300);
		}
	});


	$(document).on('click', 'a[href^="#"]', function(e) {
		e.preventDefault();
	    var id = $(this).attr('href');
	    var $id = $(id);
	    if ($id.length === 0) {
	        return;
	    }
	    var position = $id.offset().top;
	    $('body, html').animate({scrollTop: position});
	});


	var hamburger = $('#hamburger'),
		overlay = $('#overlay');

	hamburger.on('click', function() {
		if ( hamburger.hasClass('is-active') ) {
			hamburger.removeClass('is-active');
			overlay.removeClass('is-active');
			$('#hamburger-menu').addClass('hide-menu');
		} else {
			hamburger.addClass('is-active');
			overlay.addClass('is-active');
			$('#hamburger-menu').removeClass('hide-menu');
		}
	});
});
